'use client';

import { createIntl } from '@formatjs/intl';
import type { userAgent } from 'next/server';
import { PropsWithChildren } from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import type { ListsState } from '@alltrails/lists/slices/lists';
import type { MapState } from '@alltrails/maps/redux/reducer';
import type { Bootstrap } from '@alltrails/networking/types/Bootstrap';
import type Experiments from '@alltrails/types/Experiments';
import { setupListeners } from '@/utils/listenerMiddleware';
import { buildStore } from '../utils/redux';

type Props = {
  bootstrap: Bootstrap;
  browser: ReturnType<typeof userAgent>['browser'];
  experiments: Experiments;
  lists: ListsState;
  map: MapState;
  messages: ReturnType<typeof createIntl>['messages'];
  locale: ReturnType<typeof createIntl>['locale'];
  irclickid?: string;
};

setupListeners();

export default function CustomProvider({
  bootstrap,
  browser,
  experiments,
  lists,
  map,
  messages,
  locale,
  children,
  irclickid
}: PropsWithChildren<Props>) {
  const store = buildStore({
    algoliaConfigs: bootstrap.algoliaConfig,
    amplitudeAnalyticsSettings: bootstrap.amplitudeAnalyticsSettings,
    browser,
    context: bootstrap.context,
    currencyCode: bootstrap.currencyCode,
    experiments,
    features: bootstrap.features,
    irclickid,
    lists,
    map,
    plans: bootstrap.plans,
    requestCountryCode: bootstrap.requestCountryCode
  });

  return (
    <IntlProvider messages={messages} locale={locale}>
      <Provider store={store}>{children}</Provider>
    </IntlProvider>
  );
}
